const isChrome =  navigator.userAgent.indexOf('Chrome') > -1;  // 是否是谷歌
const isFirefox =  navigator.userAgent.indexOf('Firefox') > -1; // 是否是火狐

const isWin = (navigator.platform == "Win32") || (navigator.platform == "Windows");
const isMac = (navigator.platform == "Mac68K") || (navigator.platform == "MacPPC") || (navigator.platform == "Macintosh") || (navigator.platform == "MacIntel");


export {
    isChrome,
    isFirefox,
    isWin,
    isMac,
};



// WEBPACK FOOTER //
// ./src/utils/navigator.js